
import { Box, Dialog, DialogContent, DialogTitle, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery } from '@mui/material';
import React, { FunctionComponent, useEffect, useState } from 'react';
import gaiaTheme from '../../../../root-components/theme';
import { IDistributionList, IPostDistributionListGenericTeam, IPostDistributionListIndividualContacts } from '../../../../shared/services/distribution-list/distribution-list.model';
import { DistributionListIndividualContacts } from '../../../presentation-components/settings-components/distribution-list/distribution-list-individual-contacts';
import { DistributionListGenericTeam } from '../../../presentation-components/settings-components/distribution-list/distribution-list-generic-team';

export const AddDistributionListManuallyDialog: FunctionComponent<{
  open: boolean,
  closeHandler: () => void,
  successHandler: () => void,
  individualContactsOnly?: boolean,
  genericTeamOnly?: boolean,
  distributionListDetails?: IDistributionList,
  selectedUser?: { id: string, name: string, email: string }
}> = ({ open,
  closeHandler,
  successHandler,
  individualContactsOnly = false,
  distributionListDetails,
  selectedUser,
  genericTeamOnly
}) => {

    const [email, setEmail] = React.useState<string>('genericTeamContact');
    const [newDistributionListIndividualContacts, setNewDistributionListIndividualContacts] = useState<IPostDistributionListIndividualContacts>({
      listName: '',
      isGenericTeamEmail: false,
      emailAddresses: [{ name: '', emailAddress: '' }],
    })
    const [newDistributionListGenericTeam, setNewDistributionListGenericTeam] = useState<IPostDistributionListGenericTeam>({
      listName: '',
      isGenericTeamEmail: true,
      emailAddress: '',
    })
    const isMobileModeMd = useMediaQuery(gaiaTheme.breakpoints.down('md'));

    useEffect(() => {
      if (individualContactsOnly) {
        setEmail('individualContacts')
      }
      if (genericTeamOnly) {
        setEmail('genericTeamContact')
      }
    }, [])

    const emailHandler = (event: React.MouseEvent<HTMLElement>, email: string | null,) => {
      if (email) {
        setEmail(email);
      }
    }

    return (
      <Dialog open={open} onClose={closeHandler} maxWidth='xs' fullWidth>
        <Box sx={{ p: 4 }}>
          {!distributionListDetails &&
            <DialogTitle sx={{ pt: 0, pl: 0, pr: 0 }}>
              Create Distribution List
            </DialogTitle>}
          {distributionListDetails &&
            <DialogTitle sx={{ pt: 0, pl: 0, pr: 0 }}>
              Edit Distribution List
            </DialogTitle>}
          <DialogContent sx={{ pt: 0, pl: 0, pr: 0 }}>
            {!distributionListDetails && <ToggleButtonGroup
              value={email}
              exclusive
              fullWidth
              onChange={emailHandler}
              orientation={isMobileModeMd ? "vertical" : 'horizontal'}>
              <ToggleButton value="individualContacts" sx={{ width: '100%', pt: 1, pb: 1, textTransform: 'capitalize' }}>
                <Typography>Individual Contacts</Typography>
              </ToggleButton>
              <ToggleButton value="genericTeamContact" sx={{
                width: '100%', p: 1, textTransform: 'none',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
                textAlign: 'center'
              }}>
                <Typography noWrap>Generic Team Contact</Typography>
              </ToggleButton>
            </ToggleButtonGroup>}
            {email === 'individualContacts' &&
              <DistributionListIndividualContacts
                newDistributionList={newDistributionListIndividualContacts}
                closeHandler={closeHandler}
                successHandler={successHandler}
                distributionListDetails={distributionListDetails}
                selectedUser={selectedUser}
              />
            }
            {email === 'genericTeamContact' &&
              <DistributionListGenericTeam
                newDistributionList={newDistributionListGenericTeam}
                closeHandler={closeHandler}
                successHandler={successHandler}
                distributionListDetails={distributionListDetails}
              />
            }
          </DialogContent>
        </Box>
      </Dialog >
    );
  };
